import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const ArrowLeft = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '25',
    style,
  });

  return (
    <svg
      width={widthToUse}
      height={heightToUse}
      viewBox='0 0 25 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fill={primaryColorToUse}
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.4832 5.16509C13.8738 5.55561 13.8738 6.18877 13.4832 6.5793L8.19034 11.8722H19.7761C20.3284 11.8722 20.7761 12.3199 20.7761 12.8722C20.7761 13.4245 20.3284 13.8722 19.7761 13.8722H8.19034L13.4832 19.1651C13.8738 19.5556 13.8738 20.1888 13.4832 20.5793C13.0927 20.9698 12.4595 20.9698 12.069 20.5793L5.06902 13.5793C4.67849 13.1888 4.67849 12.5556 5.06902 12.1651L12.069 5.16509C12.4595 4.77456 13.0927 4.77456 13.4832 5.16509Z'
      />
    </svg>
  );
};
